import { css } from '@emotion/react';

export const multiPanelStyle = css`
  width: 100%;
  container-type: inline-size;
  container-name: submissions-list-view;
`;

export const listPanelStyle = css`
  position: relative;
  overflow: auto;
  min-width: min(100%, 400px);

  @container submissions-list-view (min-width: 800px) {
    width: 400px;
  }
`;
